const BUSINESS_ROLES = new Set(["customer_business", "customer_shop"]);
const PLANS = new Set(["free", "start", "pro"]);

export function registrationIntent(search) {
  const params = new URLSearchParams(search);
  const requestedRole = params.get("role");
  const legacyRole = requestedRole === "business" ? "customer_business" : requestedRole;
  const requestedAudience = params.get("audience");
  const requestedPlan = (params.get("plan") || "").toLowerCase();
  const audience = requestedAudience === "private" || requestedAudience === "business"
    ? requestedAudience : BUSINESS_ROLES.has(legacyRole) ? "business" : "private";
  return {
    audience,
    role: audience === "private" ? "customer_private" : legacyRole === "customer_shop" ? "customer_shop" : "customer_business",
    plan: audience === "business" && PLANS.has(requestedPlan) ? requestedPlan : "",
    driverRequested: requestedRole === "driver",
    prefillQuote: params.get("prefill") === "quote",
  };
}

// Carry only known registration context; role is always mapped to a customer role.
export function registrationLink(search, { audience, role, to = "/register" } = {}) {
  const original = new URLSearchParams(search);
  if (audience === "private" || audience === "business") original.set("audience", audience);
  if (BUSINESS_ROLES.has(role)) original.set("role", role);
  const intent = registrationIntent(original);
  const params = new URLSearchParams({ audience: intent.audience });
  if (intent.audience === "business") {
    if (intent.role === "customer_shop") params.set("role", intent.role);
    if (intent.plan) params.set("plan", intent.plan);
  }
  for (const key of ["ref", "src", "next"]) {
    if (original.get(key)) params.set(key, original.get(key));
  }
  if (intent.prefillQuote) params.set("prefill", "quote");
  return `${to}?${params.toString()}`;
}

export function registrationReturnPath(search, role) {
  if (!["customer_private", "customer_business", "customer_shop"].includes(role)) return null;
  const intent = registrationIntent(search);
  if (intent.prefillQuote) return "/app/new";
  if (BUSINESS_ROLES.has(role) && intent.plan && intent.plan !== "free") {
    return `/app/subscription?plan=${intent.plan === "start" ? "business_start" : "business_pro"}`;
  }
  return null;
}
